module.exports = __webpack_public_path__ + "static/media/pTowing_Header.ae534c0b.png";